import React from 'react'
import { Popup, Heading, Paragraph, Button, TriangleExclamationIcon } from '@quickmd-llc/design-system'

type UnsupportedPlatformPopUpProps = {
  media: 'call' | 'video'
  onClose: () => void
  onEndVisit: () => void
}

export const UnsupportedPlatformPopUp: React.FC<UnsupportedPlatformPopUpProps> = ({
  media,
  onClose,
  onEndVisit,
}: UnsupportedPlatformPopUpProps) => {
  const title = media === 'video' ? 'Unsupported video platform' : 'Unsupported call platform'
  const description =
    media === 'video' ?
      'This visit’s configured video platform is not supported. You can end the visit or close this message.'
    : 'This visit’s configured call platform is not supported. You can end the visit or close this message.'

  return (
    <Popup
      isOpen
      onClose={onClose}
      showCloseIcon
      header={{
        content: (
          <Heading level='h3' className='flex items-center gap-sp-1'>
            <TriangleExclamationIcon iconSize='l' /> {title}
          </Heading>
        ),
      }}
      body={
        <div className='w-full max-w-md rounded-lg bg-white'>
          <Paragraph className='text-text-medium'>{description}</Paragraph>
        </div>
      }
      footer={
        <div className='flex justify-end gap-sp-2'>
          <Button priority='secondary' onClick={onClose}>
            Close
          </Button>
          <Button priority='primary' theme='danger' onClick={onEndVisit}>
            End visit
          </Button>
        </div>
      }
    />
  )
}

export default UnsupportedPlatformPopUp
